import React from 'react';
import { Helmet } from 'react-helmet-async';

import { renderDeepLinkPage, buildScheme } from '../DeepLinkUtils';

export default function DraftStudentInviteRedirect() {
  const params = new URLSearchParams(window.location.search);
  const pathInviteToken = window.location.pathname.split('/').filter(Boolean).pop();
  const inviteToken = pathInviteToken || params.get('token') || undefined;
  const deepLink = inviteToken ? buildScheme(`/draft-invite/${inviteToken}`) : null;

  // Hooks must be called unconditionally at the top level
  React.useEffect(() => {
    if (!deepLink) return;
    try {
      window.location.href = deepLink;
    } catch {
      // noop
    }
  }, [deepLink]);

  if (!inviteToken) {
    window.location.href = '/';
    return null;
  }

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow, noimageindex, nosnippet, noarchive" />
      </Helmet>
      {deepLink ? renderDeepLinkPage({
        title: 'Accept Your RollOps Invitation',
        description: 'We are opening the RollOps app to finish your account setup from this invitation.',
        deepLink,
        showDownloadButtons: true,
        extraContent: (
          <div
            style={{
              marginTop: 24,
              background: 'rgba(255,255,255,0.04)',
              borderRadius: 12,
              padding: 16,
              fontSize: 13,
              color: 'rgba(255,255,255,0.7)',
            }}
          >
            <strong>Invite Token:</strong>
            <code style={{ background: 'rgba(0,0,0,0.4)', padding: '2px 6px', borderRadius: 6, marginLeft: 8 }}>{inviteToken}</code>
          </div>
        ),
      }) : null}
    </>
  );
}
